import { groupBy, sortBy } from "lodash";

export default function groupCategoriesByName(
    categories,
    tenantIds = [],
    filterType = "all"
) {
    const groupedCategories = sortBy(
        Object.entries(groupBy(categories, "name")).map(
            ([name, categories]) => ({
                name,
                id: name.trim().toLowerCase().replace(/ /g, "_"),
                ids: categories.map((category) => category.id),
                tenant_ids: categories.map((category) => category.tenant_id),
                categories,
            })
        ),
        "name"
    );

    if (!tenantIds.length) {
        return groupedCategories;
    }

    return groupedCategories.filter((category) =>
        tenantIds[getFilterFn(filterType)]((tenantId) =>
            category.tenant_ids.includes(tenantId)
        )
    );
}

function getFilterFn(filterType) {
    switch (filterType) {
        case "any":
            return "some";
        case "all":
        default:
            return "every";
    }
}
